/* ==========================================================================
   PDP V2 — Interaktion
   Galerie, Kauf-Tabs, Mengenstaffel, Abo, Accordion, Video-Wiedergabe,
   Scroll-Animation, die mobile Sticky-ATC-Leiste und das Hinzufuegen zum
   Warenkorb ueber den Cart-Slider des Themes.

   Die Trusted-Shops-Bewertungen im Hero-Kasten standen frueher am Ende
   dieser Datei und liegen jetzt in assets/pdp-v2-bewertungen.js – sie
   haengen an keinem der hiesigen Elemente und werden nur dort gebraucht,
   wo .gallery-reviews-mini steht. Geladen wird die Datei von
   sections/pdp-v2-main.liquid.
   ========================================================================== */
(function () {
  'use strict';

  function euro(cents) {
    return (cents / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  }

  function ytEmbed(id) {
    return 'https://www.youtube-nocookie.com/embed/' + id +
           '?autoplay=1&rel=0&playsinline=1&modestbranding=1';
  }

  var lightbox = null;

  function ensureLightbox() {
    if (lightbox) return lightbox;
    lightbox = document.querySelector('.pdp2-lightbox');
    if (lightbox) return lightbox;

    lightbox = document.createElement('div');
    lightbox.className = 'pdp2-lightbox';
    lightbox.innerHTML =
      '<div class="pdp2-lightbox__inner">' +
      '<button class="pdp2-lightbox__close" type="button" aria-label="Schließen">&times;</button>' +
      '<div class="pdp2-lightbox__slot"></div>' +
      '</div>';
    document.body.appendChild(lightbox);

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target.classList.contains('pdp2-lightbox__close')) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });
    return lightbox;
  }

  function openLightbox(src, orientation) {
    if (!src) return;
    var box = ensureLightbox();
    var inner = box.querySelector('.pdp2-lightbox__inner');
    var slot = box.querySelector('.pdp2-lightbox__slot');
    inner.classList.toggle('is-vertical', orientation === 'vertical');
    slot.innerHTML = '';

    if (/youtube\.com|youtu\.be/.test(src)) {
      var m = src.match(/(?:v=|youtu\.be\/|embed\/|shorts\/)([A-Za-z0-9_-]{6,})/);
      var frame = document.createElement('iframe');
      frame.src = ytEmbed(m ? m[1] : '');
      frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share';
      frame.allowFullscreen = true;
      slot.appendChild(frame);
    } else {
      var vid = document.createElement('video');
      vid.src = src; vid.controls = true; vid.autoplay = true; vid.playsInline = true;
      slot.appendChild(vid);
    }
    box.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('open');
    lightbox.querySelector('.pdp2-lightbox__slot').innerHTML = '';
    document.body.style.overflow = '';
  }

  /* Scroll-Animation: Video-Position folgt dem Scrollfortschritt.
     Braucht ein MP4 mit Keyframe je Bild, sonst ruckelt das Scrubben.
     Ohne JS oder bei prefers-reduced-motion bleibt der Block flach. */
  function initScrollVideo(wrap) {
    if (wrap.dataset.svInit === '1') return;
    wrap.dataset.svInit = '1';
    var video = wrap.querySelector('video');
    if (!video) return;

    var reduziert = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduziert) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e, obs) {
          e.forEach(function (x) {
            if (!x.isIntersecting) return;
            var p = video.play(); if (p && p.catch) p.catch(function () {});
            obs.disconnect();
          });
        }, { threshold: 0.4 }).observe(video);
      }
      return;
    }

    wrap.classList.add('is-scroll');

    var geweckt = false;
    function wecken() {
      if (geweckt) return;
      geweckt = true;
      var p = video.play();
      if (p && p.then) p.then(function () { video.pause(); video.currentTime = 0; }).catch(function () {});
    }

    var dauer = 0, offen = false;
    function aktualisieren() {
      offen = false;
      if (!dauer) return;
      var strecke = wrap.offsetHeight - window.innerHeight;
      if (strecke <= 0) return;
      var anteil = Math.min(1, Math.max(0, -wrap.getBoundingClientRect().top / strecke));
      var ziel = anteil * dauer;
      if (Math.abs(video.currentTime - ziel) > 0.01) video.currentTime = ziel;
    }
    function anstossen() {
      if (offen) return;
      offen = true;
      window.requestAnimationFrame(aktualisieren);
    }
    function bereit() {
      dauer = isFinite(video.duration) ? video.duration : 0;
      wecken(); aktualisieren();
    }

    if (video.readyState >= 1) bereit(); else video.addEventListener('loadedmetadata', bereit);
    window.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', anstossen);
  }

  function initRoot(root) {
    // Das Script-Tag steht in mehreren Sections -> mehrfach ausgefuehrt.
    if (root.dataset.pdp2Init === '1') return;
    root.dataset.pdp2Init = '1';

    root.querySelectorAll('[data-pdp2-scrollvideo]').forEach(initScrollVideo);

    root.querySelectorAll('[data-pdp2-video]').forEach(function (el) {
      el.addEventListener('click', function () {
        openLightbox(el.getAttribute('data-pdp2-video'), el.getAttribute('data-orientation'));
      });
    });

    root.querySelectorAll('[data-pdp2-inline-video]').forEach(function (el) {
      var starten = function () {
        var id = el.getAttribute('data-pdp2-inline-video');
        if (!id || el.classList.contains('is-playing')) return;
        var frame = document.createElement('iframe');
        frame.src = ytEmbed(id);
        frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share';
        frame.allowFullscreen = true;
        frame.title = el.getAttribute('data-titel') || '';
        el.innerHTML = '';
        el.appendChild(frame);
        el.classList.add('is-playing');
        el.removeAttribute('role'); el.removeAttribute('tabindex'); el.removeAttribute('aria-label');
      };
      el.addEventListener('click', starten);
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); starten(); }
      });
    });

    // YouTube-Thumbnails aufwerten: oardefault/maxresdefault existieren nicht
    // immer, YouTube liefert dann einen 120px-Platzhalter statt eines 404.
    root.querySelectorAll('img[data-yt-id]').forEach(function (img) {
      var id = img.getAttribute('data-yt-id');
      img.removeAttribute('data-yt-id');
      if (!id) return;
      var kandidaten = [
        'https://i.ytimg.com/vi/' + id + '/oardefault.jpg',
        'https://i.ytimg.com/vi/' + id + '/maxresdefault.jpg'
      ];
      (function versuche(i) {
        if (i >= kandidaten.length) return;
        var probe = new Image();
        probe.onload = function () {
          if (probe.naturalWidth > 120) img.src = kandidaten[i]; else versuche(i + 1);
        };
        probe.onerror = function () { versuche(i + 1); };
        probe.src = kandidaten[i];
      })(0);
    });

    root.querySelectorAll('[data-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.parentElement.classList.toggle('open');
        btn.setAttribute('aria-expanded', btn.parentElement.classList.contains('open'));
      });
    });

    var configEl = root.querySelector('[data-pdp2-config]');
    if (!configEl) return;
    var cfg;
    try { cfg = JSON.parse(configEl.textContent); } catch (e) { return; }

    /* ---------- Galerie ---------- */
    var mainImg = root.querySelector('[data-pdp2-main-image]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.thumb'));

    function activateThumb(thumb) {
      var video = thumb.getAttribute('data-video');
      if (video) { openLightbox(video, thumb.getAttribute('data-video-orientation')); return; }
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      var full = thumb.getAttribute('data-full');
      if (full && mainImg) {
        mainImg.src = full;
        if (thumb.getAttribute('data-srcset')) mainImg.srcset = thumb.getAttribute('data-srcset');
        mainImg.alt = thumb.getAttribute('data-alt') || '';
      }
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { activateThumb(t); }); });

    function cycleGallery(dir) {
      var bilder = thumbs.filter(function (t) { return !t.getAttribute('data-video'); });
      if (!bilder.length) return;
      var i = bilder.findIndex(function (t) { return t.classList.contains('active'); });
      activateThumb(bilder[(i + dir + bilder.length) % bilder.length]);
    }
    var arrowL = root.querySelector('.gallery-arrow.left');
    var arrowR = root.querySelector('.gallery-arrow.right');
    if (arrowL) arrowL.addEventListener('click', function () { cycleGallery(-1); });
    if (arrowR) arrowR.addEventListener('click', function () { cycleGallery(1); });

    /* ---------- Kauf-Tabs ---------- */
    var sellingPlanInput = root.querySelector('[data-pdp2-selling-plan]');
    var tabBtns = Array.prototype.slice.call(root.querySelectorAll('.tab-btn'));
    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab');
        tabBtns.forEach(function (b) { b.classList.remove('active'); });
        root.querySelectorAll('.tab-panel').forEach(function (p) { p.classList.remove('active'); });
        btn.classList.add('active');
        var panel = root.querySelector('.tab-panel[data-panel="' + target + '"]');
        if (panel) panel.classList.add('active');
        syncSellingPlan(); render();
      });
    });

    var aboTiers = Array.prototype.slice.call(root.querySelectorAll('[data-tier]'));
    aboTiers.forEach(function (el) {
      el.addEventListener('click', function () {
        aboTiers.forEach(function (o) { o.classList.remove('selected'); });
        el.classList.add('selected');
        syncSellingPlan(); render();
      });
    });

    function aboActive() {
      var panel = root.querySelector('.tab-panel[data-panel="abo"]');
      return !!(panel && panel.classList.contains('active'));
    }
    function selectedAbo() { return root.querySelector('[data-tier].selected'); }

    function syncSellingPlan() {
      if (!sellingPlanInput) return;
      if (aboActive()) {
        var tier = selectedAbo();
        sellingPlanInput.value = tier ? (tier.getAttribute('data-selling-plan-id') || '') : '';
        var q = tier && tier.getAttribute('data-quantity');
        if (q) qty = parseInt(q, 10) || 1;
      } else {
        sellingPlanInput.value = '';
      }
    }

    /* ---------- Mengenstaffel ---------- */
    var qty = 1;
    var maxQty = cfg.maxQuantity || 20;
    var tiers = cfg.tiers || [];
    var qtyValueEl = root.querySelector('[data-pdp2-qty-value]');
    var qtyMinusEl = root.querySelector('[data-pdp2-qty-minus]');
    var qtyPlusEl = root.querySelector('[data-pdp2-qty-plus]');
    var qtyInput = root.querySelector('[data-pdp2-qty-input]');
    var optPriceTotalEl = root.querySelector('[data-pdp2-opt-total]');
    var optPriceUnitEl = root.querySelector('[data-pdp2-opt-unit]');
    var qtyDetailEl = root.querySelector('[data-pdp2-qty-detail]');
    var tierRows = Array.prototype.slice.call(root.querySelectorAll('.qty-tier-row'));
    var stickyPriceEl = root.querySelector('[data-pdp2-sticky-price]');

    // Staffeln zu anklickbaren Kacheln umbauen. Label bleibt der server-
    // gerenderte Text (dort stecken die Ein-/Mehrzahl-Einstellungen), der
    // Rabatt kommt aus cfg.tiers -- kein Text-Parsing.
    tierRows.forEach(function (row) {
      var min = parseInt(row.getAttribute('data-min'), 10) || 1;
      var label = '';
      Array.prototype.forEach.call(row.childNodes, function (n) {
        if (n.nodeType === 3) label += n.textContent;
      });
      label = label.replace(/\s+/g, ' ').trim();

      var disc = discountFor(min);
      row.textContent = '';

      var labelEl = document.createElement('span');
      labelEl.className = 'qt-label';
      labelEl.textContent = label;
      row.appendChild(labelEl);

      if (disc > 0) {
        var badge = document.createElement('span');
        badge.className = 'qt-badge';
        badge.textContent = '−' + disc + '%';
        row.appendChild(badge);
      }

      row.setAttribute('role', 'button');
      row.setAttribute('tabindex', '0');
      var waehlen = function () { if (aboActive()) return; qty = min; render(); };
      row.addEventListener('click', waehlen);
      row.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); waehlen(); }
      });
    });

    function currentVariant() {
      var id = variantInput ? parseInt(variantInput.value, 10) : cfg.variants[0].id;
      for (var i = 0; i < cfg.variants.length; i++) if (cfg.variants[i].id === id) return cfg.variants[i];
      return cfg.variants[0];
    }

    function discountFor(q) {
      var d = 0;
      for (var i = 0; i < tiers.length; i++) if (q >= tiers[i].min) d = tiers[i].discount;
      return d;
    }

    function render() {
      var v = currentVariant();
      var base = v.price;
      var isAbo = aboActive();
      if (isAbo) {
        var tier = selectedAbo();
        qty = tier ? (parseInt(tier.getAttribute('data-quantity'), 10) || 1) : 1;
      }
      if (qtyValueEl) qtyValueEl.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
      if (qtyMinusEl) qtyMinusEl.disabled = qty <= 1;
      if (qtyPlusEl) qtyPlusEl.disabled = qty >= maxQty;

      var disc = isAbo ? 0 : discountFor(qty);
      var unit = Math.round(base * (100 - disc) / 100);
      var total = unit * qty;

      if (optPriceTotalEl) optPriceTotalEl.textContent = euro(total);
      if (optPriceUnitEl) {
        optPriceUnitEl.textContent = (qty > 1 && !isAbo)
          ? ('−' + disc + '% · ' + euro(unit) + (cfg.labels.perPiece || '/Stück')) : '';
      }
      if (qtyDetailEl) {
        qtyDetailEl.textContent = qty === 1
          ? cfg.labels.onceSingle
          : qty + ' ' + cfg.labels.unitPlural + ' · ' + cfg.labels.onceMulti;
      }
      tierRows.forEach(function (row) {
        var min = parseInt(row.getAttribute('data-min'), 10);
        var max = parseInt(row.getAttribute('data-max'), 10);
        var an = !isAbo && qty >= min && qty <= max;
        row.classList.toggle('active', an);
        row.setAttribute('aria-pressed', an ? 'true' : 'false');
      });
      if (stickyPriceEl) stickyPriceEl.textContent = euro(total);
    }

    if (qtyMinusEl) qtyMinusEl.addEventListener('click', function () { if (qty > 1) { qty--; render(); } });
    if (qtyPlusEl) qtyPlusEl.addEventListener('click', function () { if (qty < maxQty) { qty++; render(); } });

    var variantInput = root.querySelector('[data-pdp2-variant-input]');
    var variantSelect = root.querySelector('[data-pdp2-variant-select]');
    var priceMainEl = root.querySelector('[data-pdp2-price-main]');
    var priceUnitEl = root.querySelector('[data-pdp2-price-unit]');
    var ctaBtn = root.querySelector('.cta-main');

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        if (variantInput) variantInput.value = variantSelect.value;
        var v = currentVariant();
        if (priceMainEl) priceMainEl.textContent = euro(v.price);
        if (priceUnitEl && v.unitPrice) priceUnitEl.textContent = v.unitPrice;
        if (ctaBtn) {
          ctaBtn.disabled = !v.available;
          ctaBtn.textContent = v.available ? cfg.labels.addToCart : cfg.labels.soldOut;
        }
        render();
      });
    }

    root.querySelectorAll('.chip').forEach(function (c) {
      c.addEventListener('click', function () {
        root.querySelectorAll('.chip').forEach(function (o) { o.classList.remove('active'); });
        c.classList.add('active');
      });
    });

    /* ---------- In den Warenkorb, ohne Seitenwechsel ----------
       Das Theme steht auf cartType "drawer" und hat einen Cart-Slider
       (<cart-drawer id="mini-cart">). Unser Formular hat bisher normal
       abgeschickt und damit die grosse Warenkorbseite geoeffnet.

       Hier derselbe Ablauf wie im theme-eigenen Produktformular:
         1. POST auf /cart/add.js, im Rumpf sections=mini-cart – die
            Antwort enthaelt dann das fertig gerenderte Markup des Sliders.
         2. /cart.js holen, weil die Add-Antwort nur die neue Position
            liefert, das Theme aber den ganzen Warenkorb erwartet.
         3. cart:updated und cart:refresh auf documentElement feuern.
            openMiniCart:true ist das Signal, den Slider zu oeffnen.

       Steht cartType nicht auf "drawer" (Theme-Einstellung), bleibt es
       beim normalen Abschicken auf die Warenkorbseite. */
    var form = root.querySelector('[data-pdp2-form]');

    function cartFehler(text) {
      if (!form) return;
      var box = form.querySelector('[data-pdp2-cart-fehler]');
      if (!box) {
        box = document.createElement('p');
        box.setAttribute('data-pdp2-cart-fehler', '');
        box.setAttribute('role', 'alert');
        // Stil direkt hier: das Element entsteht nur im Fehlerfall und
        // haette in pdp-v2.css sonst keinen zweiten Leser.
        box.style.cssText = 'margin:0 0 10px;font-size:13px;line-height:20px;color:#b3261e;';
        form.insertBefore(box, form.querySelector('.cta-main'));
      }
      box.textContent = text;
    }

    function drawerModus() {
      var e = window.themeVariables && window.themeVariables.settings;
      return !!(e && e.cartType === 'drawer');
    }

    function inDenWarenkorb() {
      if (!form) return;
      var knopf = form.querySelector('.cta-main');
      var routen = window.themeVariables.routes;
      var nutzlast = new FormData(form);

      // Ein leeres selling_plan weist die Cart-API als ungueltig zurueck.
      if (!nutzlast.get('selling_plan')) nutzlast.delete('selling_plan');
      // Genau diese Section rendert das Theme aus der Antwort neu.
      nutzlast.append('sections', 'mini-cart');

      if (knopf) { knopf.setAttribute('disabled', ''); knopf.setAttribute('aria-busy', 'true'); }
      var alteMeldung = form.querySelector('[data-pdp2-cart-fehler]');
      if (alteMeldung) alteMeldung.textContent = '';

      fetch(routen.cartAddUrl + '.js', {
        method: 'POST',
        body: nutzlast,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (antwort) {
        return antwort.json().then(function (inhalt) {
          return { ok: antwort.ok, inhalt: inhalt };
        });
      }).then(function (r) {
        if (!r.ok) {
          throw new Error((r.inhalt && (r.inhalt.description || r.inhalt.message)) || (cfg.labels && cfg.labels.addFailed) || 'Hinzufügen fehlgeschlagen');
        }
        return fetch(routen.cartUrl + '.js').then(function (a) { return a.json(); }).then(function (warenkorb) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true, detail: { cart: warenkorb }
          }));
          warenkorb.sections = r.inhalt.sections;
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true, detail: { cart: warenkorb, openMiniCart: true }
          }));
        });
      }).catch(function (fehler) {
        cartFehler(fehler && fehler.message ? fehler.message : 'Das Produkt konnte nicht hinzugefügt werden.');
      }).then(function () {
        if (knopf) { knopf.removeAttribute('disabled'); knopf.removeAttribute('aria-busy'); }
      });
    }

    if (form) {
      form.addEventListener('submit', function (ev) {
        if (!drawerModus()) return;   // dann normal auf die Warenkorbseite
        ev.preventDefault();
        inDenWarenkorb();
      });
    }

    var stickyAtc = root.querySelector('[data-pdp2-sticky]');
    var buyBox = root.querySelector('.buy-box');
    if (stickyAtc && buyBox) {
      var stickyBtn = stickyAtc.querySelector('.sa-btn');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          if (!form) return;
          // requestSubmit loest das submit-Ereignis aus und laeuft damit
          // durch den Handler oben. form.submit() taete das NICHT und
          // wuerde den Slider umgehen – deshalb der getrennte Fallback.
          if (form.requestSubmit) { form.requestSubmit(); return; }
          if (drawerModus()) inDenWarenkorb(); else form.submit();
        });
      }
      var toggleSticky = function () {
        if (window.innerWidth >= 980) { stickyAtc.classList.remove('show'); return; }
        stickyAtc.classList.toggle('show', buyBox.getBoundingClientRect().bottom < 0);
      };
      window.addEventListener('scroll', toggleSticky, { passive: true });
      window.addEventListener('resize', toggleSticky);
      toggleSticky();
    }

    syncSellingPlan();
    render();
  }

  function boot() {
    document.querySelectorAll('[data-pdp2-root]').forEach(initRoot);
    document.querySelectorAll('[data-pdp2-scrollvideo]').forEach(initScrollVideo);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-pdp2-root]');
    if (root) initRoot(root);
    e.target.querySelectorAll('[data-pdp2-scrollvideo]').forEach(initScrollVideo);
  });
})();
